/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/prefer-regexp-exec */
const validation = {
	email: /^[a-z\_\-\.]+@[a-z\_\-]+\.[a-z]{2,}$/i,
	number: /^\-?[0-9]{1,6}$/,
	color: /^\#[0-9A-Fa-f]{6}$/,
	date: /^[0-9]{4}\-[0-9]{1,2}\-[0-9]{1,2}$/,
};

export function validate(val, rule) {
	let result = true;
	if (rule) {
		if (typeof val === "string" && val !== "") {
			rule = validation[rule] || rule;
			if (typeof rule === "function") {
				result = rule.call(this, val);
			} else {
				result = !!val.match(rule);
			}
		}
	}
	return result;
}
